module.exports = __webpack_public_path__ + "static/media/25_4.f19bd057.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/How it works/25_4.png
// module id = 304
// module chunks = 0